module.exports = __webpack_public_path__ + "static/media/lucario.79cd1206.png";